import React, { useMemo, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SummaryWrapper } from '../../../components/SummaryWrapper/';
import { Button, Dropdown } from '../../../components';
import { UploadOutlined, DownOutlined } from '@ant-design/icons';
import { DISCOVERY_ROUTE_CONFIG } from '../../../constants/routes';

import './dashboard.scss';

export const DiscoveryDashboard = () => {
    const navigate = useNavigate();
    const [dashboardHasNoData, setDashboardHasNoData] = useState(false); // Controlled by SummaryWrapper
    const importButtonDropdown = useMemo(
        () => [
            { key: '1', label: 'RVTools', onClick: () => navigate(DISCOVERY_ROUTE_CONFIG.rvTools.path) },
            { key: '2', label: 'AWS Transform', onClick: () => navigate(DISCOVERY_ROUTE_CONFIG.awsTransform.path) },
        ],
        [navigate],
    );

    const handleFilterClick = useCallback(
        (filters) => {
            navigate(DISCOVERY_ROUTE_CONFIG.inventory.path, { state: { filters } });
        },
        [navigate],
    );

    return (
        <div className="discovery-dashboard">
            <SummaryWrapper
                setDashboardHasNoData={setDashboardHasNoData}
                canRenderImportButton={true}
                title="Discovery"
                showMarkReadyInfo={false}
                collapsible={false}
                onFilterClick={handleFilterClick}
            />
            {dashboardHasNoData && (
                <Dropdown menu={{ items: importButtonDropdown }} placement="bottomRight" arrow>
                    <Button shape="round" type="primary" icon={<UploadOutlined />} className="import-button">
                        Import <DownOutlined />
                    </Button>
                </Dropdown>
            )}
        </div>
    );
};
